// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3aBms","insightsList":"newBusinessInsightsMenu_insightsList__11vp8","active":"newBusinessInsightsMenu_active__AawHc"};